import * as Factory from 'factory.ts'
import faker from 'faker'

import type { Components } from '@webapp/api/integrations/client'
import { IntegrationEntities } from '@webapp/models/enums/IntegrationEntity'
import { IntegrationSyncLogActions } from '@webapp/models/enums/IntegrationSyncLogAction'
import { IntegrationSyncResponseStatuses } from '@webapp/models/enums/IntegrationSyncResponseStatus'

export const SyncLocalEntityMetadataStub =
  Factory.Sync.makeFactory<Components.Schemas.LocalEntityMetadata>({
    description: Factory.each(() => faker.random.word()),
  })

const syncResponseStubLocalEntityMetadata = SyncLocalEntityMetadataStub.build()

export const VendorSyncLogResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.SyncLogResponse>({
    id: Factory.each(() => faker.random.uuid()),
    status: IntegrationSyncResponseStatuses.COMPLETED,
    action: IntegrationSyncLogActions.CREATED,
    message: Factory.each(() => faker.random.words(5)),
    created_at: Factory.each(() => faker.date.recent(1).toISOString()),
    local_entity: IntegrationEntities.VENDOR,
    local_entity_ref: Factory.each(() => faker.random.number().toString()),
    root_local_entity_metadata: syncResponseStubLocalEntityMetadata,
  })

export const AccountCodeSyncLogResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.SyncLogResponse>({
    id: Factory.each(() => faker.random.uuid()),
    status: IntegrationSyncResponseStatuses.COMPLETED,
    action: IntegrationSyncLogActions.CREATED,
    message: Factory.each(() => faker.random.words(5)),
    created_at: Factory.each(() => faker.date.recent(1).toISOString()),
    local_entity: IntegrationEntities.ACCOUNT_CODE,
    local_entity_ref: Factory.each(() => faker.random.number().toString()),
    root_local_entity_metadata: syncResponseStubLocalEntityMetadata,
  })

export const IntegrationSyncLogsEmptyResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.PaginatedResponseSyncLogResponse>(
    {
      data: [],
      metadata: {
        pagination: {
          count: 0,
          current_page: 0,
          num_pages: 0,
          page_size: 0,
        },
      },
    }
  )

export const IntegrationVendorSyncLogsResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.PaginatedResponseSyncLogResponse>(
    {
      data: [VendorSyncLogResponseStub.build()],
      metadata: {
        pagination: {
          count: 1,
          current_page: 1,
          num_pages: 1,
          page_size: 1,
        },
      },
    }
  )

export const IntegrationAccountCodeSyncLogsResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.PaginatedResponseSyncLogResponse>(
    {
      data: [AccountCodeSyncLogResponseStub.build()],
      metadata: {
        pagination: {
          count: 1,
          current_page: 1,
          num_pages: 1,
          page_size: 1,
        },
      },
    }
  )

export const IntegrationMultipleVendorSyncLogsResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.PaginatedResponseSyncLogResponse>(
    {
      data: [
        VendorSyncLogResponseStub.build(),
        VendorSyncLogResponseStub.build(),
      ],
      metadata: {
        pagination: {
          count: 2,
          current_page: 1,
          num_pages: 2,
          page_size: 1,
        },
      },
    }
  )

export const IntegrationMultipleAccountCodesSyncLogsResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.PaginatedResponseSyncLogResponse>(
    {
      data: [
        AccountCodeSyncLogResponseStub.build(),
        AccountCodeSyncLogResponseStub.build(),
      ],
      metadata: {
        pagination: {
          count: 2,
          current_page: 1,
          num_pages: 2,
          page_size: 1,
        },
      },
    }
  )

export const IntegrationSyncLogResponseStub =
  Factory.Sync.makeFactory<Components.Schemas.SyncLogResponse>({
    id: Factory.each(() => faker.random.uuid()),
    status: IntegrationSyncResponseStatuses.COMPLETED,
    action: IntegrationSyncLogActions.CREATED,
    message: Factory.each(() => faker.random.words(5)),
    created_at: Factory.each(() => faker.date.recent(1).toISOString()),
    local_entity: IntegrationEntities.VENDOR,
    local_entity_ref: Factory.each(() => faker.random.number().toString()),
    root_local_entity_metadata: syncResponseStubLocalEntityMetadata,
  })
